import axios from 'axios';

import { post, get, put, headers, patch } from './apiHelper';

class AdminClient {
    static affinitySettings(userId, session) {
        return get(`/v1/admin/users/${userId}/affinity_settings`, session);
    }

    static universities(session) {
        return get(`/v1/admin/universities/universities_for_affinity`, session);
    }

    static companies(session) {
        return get(`/v1/admin/companies/companies_for_affinity`, session);
    }

    static hobbies(session) {
        return get(`/v1/admin/hobbies/all`, session);
    }

    static societalAffiliations(session) {
        return get(`/v1/admin/societal_affiliations/all`, session);
    }

    static citiesForAffinities(session) {
        return get(`/v1/admin/cities/cities_for_affinity`, session);
    }

    static personas(session) {
        return get(`/v1/admin/personas`, session);
    }

    static getTeamHubspotId(session) {
        return get(`/v1/admin/teams/getHubspotId`, session);
    }

    static saveAffinities(userId, payload, session) {
        return post(`/v1/admin/users/${userId}/affinities`, session, payload);
    }

    static multiHeaders(session) {
        return {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
        };
    }

    static get(endpoint, session, params = {}, options = {}) {
       return get(endpoint, session, params, options)
    }

    static post(endpoint, session, params = {}, multi=false, options = {}) {
        if (multi) {
            return axios.post(
                endpoint,
                params,
                {
                    headers: this.multiHeaders(session)
                }
            );
        }

        return post(endpoint, session, params, options)
    }

    static put(endpoint, session, params = {}, multi = false) {
        return put(endpoint, session, params, multi);
    }

    static patch(endpoint, session, params = {}) {
        return patch(endpoint, session, params);
    }

    static delete(endpoint, session, params = {}) {
        return axios.delete(
            endpoint,
            {
                params,
                headers: headers(session)
            }
        );
    }

    static uploadFile(endpoint, session, file) {
        return axios.post(
            endpoint,
            file,
            {
                headers: this.multiHeaders(session)
            }
        );
    }
}

export default AdminClient;
